import { RecoveryCodesPrintModal, useRecoveryCodesGeneration } from '@dreryk/egabinet-security-frontend';
import { PromiseVoidFunction } from '@dreryk/react-common';

import { CreateAssociationPanel } from './createAssociation/CreateAssociationPanel';
import { ExistingAssociationPanel } from './existingAssociation/ExistingAssociationPanel';
import { MfaSettingsLoader } from './MfaSettings.loader';

export const MfaSettings = (): JSX.Element => {
   const recoveryCodesGenerationFlow = useRecoveryCodesGeneration();

   const handleCreateSuccess = (refetch: () => Promise<void>): PromiseVoidFunction => {
      return async () => {
         return refetch().then(() => recoveryCodesGenerationFlow.generateCodes());
      };
   };

   return (
      <MfaSettingsLoader>
         {({ timeBaseAuthenticationConfiguration, refetch }) => {
            return timeBaseAuthenticationConfiguration ? (
               <>
                  <ExistingAssociationPanel
                     activationDate={timeBaseAuthenticationConfiguration.activationDate}
                     onAssociationRemoveSuccess={refetch}
                  />
                  <RecoveryCodesPrintModal
                     isOpen={recoveryCodesGenerationFlow.printModal.isOpen}
                     onClose={recoveryCodesGenerationFlow.printModal.close}
                     result={recoveryCodesGenerationFlow.printModal.result}
                  />
               </>
            ) : (
               <CreateAssociationPanel onAssociationCreateSuccess={handleCreateSuccess(refetch)} />
            );
         }}
      </MfaSettingsLoader>
   );
};
